// Report Draft Action Types

// Save Draft
export const SAVE_REPORT_DRAFT = 'SAVE_REPORT_DRAFT';
export const SAVE_REPORT_DRAFT_SUCCESS = 'SAVE_REPORT_DRAFT_SUCCESS';
export const SAVE_REPORT_DRAFT_FAILURE = 'SAVE_REPORT_DRAFT_FAILURE';

// Fetch Draft
export const FETCH_REPORT_DRAFT = 'FETCH_REPORT_DRAFT';
export const FETCH_REPORT_DRAFT_SUCCESS = 'FETCH_REPORT_DRAFT_SUCCESS';
export const FETCH_REPORT_DRAFT_FAILURE = 'FETCH_REPORT_DRAFT_FAILURE';

// Fetch Draft Versions
export const FETCH_REPORT_DRAFT_VERSIONS = 'FETCH_REPORT_DRAFT_VERSIONS';
export const FETCH_REPORT_DRAFT_VERSIONS_SUCCESS = 'FETCH_REPORT_DRAFT_VERSIONS_SUCCESS';
export const FETCH_REPORT_DRAFT_VERSIONS_FAILURE = 'FETCH_REPORT_DRAFT_VERSIONS_FAILURE';

// Clear Draft State
export const CLEAR_REPORT_DRAFT = 'CLEAR_REPORT_DRAFT';
export const CLEAR_SAVE_DRAFT_STATUS = 'CLEAR_SAVE_DRAFT_STATUS';

// Report Types Enum
export const REPORT_TYPES = {
  MATERIAL_SHEET: 'MATERIAL_SHEET',
  VISUAL_INSPECTION: 'VISUAL_INSPECTION',
  JOINT_FIT_UP: 'JOINT_FIT_UP',
  ALIGNMENT_VERIFICATION: 'ALIGNMENT_VERIFICATION',
  PRODUCTION_SHEET: 'PRODUCTION_SHEET',
  PRODUCTION_SHEET_MAIN: 'PRODUCTION_SHEET_MAIN',
  INSPECTION_RELEASE_NOTE: 'INSPECTION_RELEASE_NOTE',
  WELD_REPORT: 'WELD_REPORT',
  // Equipment Registry Reports (per tab)
  EQUIPMENT_WELDING_REPORT: 'EQUIPMENT_WELDING_REPORT',
  EQUIPMENT_NDE_REPORT: 'EQUIPMENT_NDE_REPORT',
  EQUIPMENT_QC_REPORT: 'EQUIPMENT_QC_REPORT',
  EQUIPMENT_COATING_REPORT: 'EQUIPMENT_COATING_REPORT',
  EQUIPMENT_HYDRO_REPORT: 'EQUIPMENT_HYDRO_REPORT',
  EQUIPMENT_TORQUING_REPORT: 'EQUIPMENT_TORQUING_REPORT',
  // Consumable Registry Reports (per tab)
  CONSUMABLE_WIRE_REPORT: 'CONSUMABLE_WIRE_REPORT',
  CONSUMABLE_GAS_REPORT: 'CONSUMABLE_GAS_REPORT',
  CONSUMABLE_NDE_REPORT: 'CONSUMABLE_NDE_REPORT',
  CONSUMABLE_COATING_REPORT: 'CONSUMABLE_COATING_REPORT',
  CONSUMABLE_HYDRO_REPORT: 'CONSUMABLE_HYDRO_REPORT',
  CONSUMABLE_TORQUING_REPORT: 'CONSUMABLE_TORQUING_REPORT',
  // Consolidated Material Registry Draft Types
  MATERIAL_REGISTRY_EQUIPMENT: 'MATERIAL_REGISTRY_EQUIPMENT',
  MATERIAL_REGISTRY_CONSUMABLE: 'MATERIAL_REGISTRY_CONSUMABLE',
  MATERIAL_REGISTRY_MISCELLANEOUS: 'MATERIAL_REGISTRY_MISCELLANEOUS',
  REGISTRY_MISCELLANEOUS_REPORT: 'REGISTRY_MISCELLANEOUS_REPORT',
  // QC Inspection Personnel Report
  QC_INSPECTION_PERSONNEL_REPORT: 'QC_INSPECTION_PERSONNEL_REPORT',
  HYDRO_PERSONNEL_REPORT: 'HYDRO_PERSONNEL_REPORT',
  TORQUING_PERSONNEL_REPORT: 'TORQUING_PERSONNEL_REPORT',
  // Welder Certification & Qualification register report (personnel-documents API group key)
  WELDER_CERTIFICATION_QUALIFICATION_REPORT: 'WELDER_CERTIFICATION_QUALIFICATION_REPORT',
  /** Conformity certificate / report (project-level draft) */
  CERTIFICATE_OF_CONFORMITY_REPORT: 'CERTIFICATE_OF_CONFORMITY_REPORT',
  /** Production assembly report (registry report documents API group key) */
  PRODUCTION_ASSEMBLY_REPORT: 'PRODUCTION_ASSEMBLY_REPORT'
};  

